import React, {Component} from "react";
import UsageLineChart from "../chart/line-chart.component";
import Moment from 'moment';

class MonthlyTrend extends Component {
    render() {       
        return (
           <div className="usage-spend-wrapper">
                <UsageLineChart
                    data={this.props.dataSixMonths}
                    invoiceMonth={this.props.invoiceMonth}
                    ledger={this.props.ledger}
                    setRef={this.props.setRef}
                    dateCurrentMonth={this.props.dateCurrentMonth}
                    selectedMonth={this.props.selectedMonth}
                />
            </div>
        )
    }
}

export default MonthlyTrend
